import React from "react";
import Icon from "@material-ui/core/Icon";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { useQuery } from "@apollo/client";
import { GET_CAMAROO_DASHBOARD_DATA } from "graphql/query/admin";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import CollectionsIcon from "@material-ui/icons/Collections";
import WorkOutlineIcon from "@material-ui/icons/WorkOutline";
import SubscriptionsIcon from "@material-ui/icons/Subscriptions";
import SchoolIcon from "@material-ui/icons/School";
import { statCardStyles } from "../dashboardStyles";
import { UNAUTHORIZED_ACCESS } from "config/common";

export default function StatCard({ setGraphType, selectedType }) {
  const classes = statCardStyles();

  const { data, loading, error } = useQuery(GET_CAMAROO_DASHBOARD_DATA, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 160 }}>
        Loading...
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ display: "flex", alignItems: "flex-start", color: "red", flexDirection: "column" }}>
        {error?.message === UNAUTHORIZED_ACCESS ? (
          <>
            <p><strong>🔒 Access Restricted</strong></p>
            <p>You don't have the necessary permissions to view this content.</p>
          </>
        ) : (
          <p>Error: {error.message}</p>
        )}
      </div>
    );
  }

  const stats = [
    {
      icon: PersonOutlineOutlinedIcon,
      numCount: data?.dashboard?.totalUsers ?? "0",
      title: "Total Users",
      color: "#3B82F6",
      type: "users",
    },
    {
      icon: CollectionsIcon,
      numCount: data?.dashboard?.totalPortfolios ?? "0",
      title: "Total Portfolios",
      color: "#8B5CF6",
      type: "portfolios",
    },
    {
      icon: WorkOutlineIcon,
      numCount: data?.dashboard?.totalOpportunities ?? "0",
      title: "Total Opportunities",
      color: "#06B6D4",
      type: "opportunities",
    },
    {
      icon: SubscriptionsIcon,
      numCount: data?.dashboard?.totalSubscriptions ?? "0",
      title: "Total Subscriptions",
      color: "#F59E0B",
      type: "subscriptions",
    },
    {
      icon: SchoolIcon,
      numCount: data?.dashboard?.totalCoursePurchases ?? "0",
      title: "Total Course Purchases",
      color: "#10B981",
      type: "coursePurchases",
    },
  ];

  return (
    <Grid container className={`${classes.root} ${classes.mainGrid}`}>
      <Grid item className={classes.wrapper}>
        <Grid container item lg={12} spacing={2}>
          {stats.map((value) => (
            <Grid key={value.type} item xs={12} sm={6} md={4} lg={2}>
              <Paper
                className={classes.paper}
                style={{
                  backgroundColor: value.color,
                  borderRadius: 6,
                  border: selectedType === value.type ? "3px solid #000" : "none",
                  cursor: "pointer",
                  transition: "transform 0.15s ease, box-shadow 0.15s ease",
                  transform: selectedType === value.type ? "translateY(-2px)" : "none",
                  boxShadow: selectedType === value.type ? "0 4px 12px rgba(0,0,0,0.2)" : "none",
                }}
                onClick={() => setGraphType(value.type)}
              >
                <Grid item className={classes.iconBox}>
                  <Typography className={`${classes.icon} ${classes.backgroundTransparent}`}>
                    <Icon style={{ color: "#FFFFFF" }}>
                      <value.icon style={{ color: "#FFFFFF" }} />
                    </Icon>
                  </Typography>
                </Grid>
                <Grid item>
                  <Grid item className={`${classes.dataBox} ${classes.dFlex}`}>
                    <Grid item>
                      <Paper className={classes.dataValues}>{value.numCount}</Paper>
                    </Grid>
                  </Grid>
                  <Typography className={classes.titleBox}>{value.title}</Typography>
                </Grid>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}
